import React, { useState } from 'react';
import { Button, FadeIn } from '../components/ui';
import { fmtDate } from '../theme';
import { useAuth } from '../context/AuthContext';

// Shown to a staff member whose leaving date has passed (offboarded).
export default function AccessEnded() {
  const { user, refreshUser, logout } = useAuth();
  const [checking, setChecking] = useState(false);

  const check = async () => {
    setChecking(true);
    await refreshUser();
    setChecking(false);
  };

  return (
    <div className="app-shell">
      <div className="screen screen--plain" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 30, minHeight: '100vh',
      }}>
        <FadeIn style={{ textAlign: 'center', maxWidth: 420 }}>
          <div style={{
            width: 110, height: 110, borderRadius: '50%', background: '#FBE6E9', margin: '0 auto',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48,
          }}>🔒</div>
          <h1 style={{ fontSize: 24, fontWeight: 800, marginTop: 20 }}>Account access ended</h1>
          <p className="muted" style={{ fontSize: 14.5, marginTop: 10, lineHeight: 1.5 }}>
            Your access ended{user?.leavingDate ? ` on ${fmtDate(user.leavingDate)}` : ''}. Please contact the admin
            to re-join. Once re-activated, tap below to continue.
          </p>
          <Button title={checking ? 'Checking…' : 'Check access'} onClick={check} disabled={checking}
            style={{ marginTop: 26, maxWidth: 240, marginLeft: 'auto', marginRight: 'auto' }} />
          <button onClick={logout} className="muted" style={{ marginTop: 16, fontWeight: 600 }}>Logout</button>
        </FadeIn>
      </div>
    </div>
  );
}
